import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import mediaService from './mediaService'

const initialState = {
    data: '',
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

export const getScreenshot = createAsyncThunk('media/getScreenshot', async (query, thunkAPI) => {
    try {
        return await mediaService.getScreenshot(query)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        // console.log(error)
        return thunkAPI.rejectWithValue(message)
    }
})

export const mediaSlice = createSlice({
    name: 'media',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getScreenshot.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getScreenshot.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.data = action.payload
            })
            .addCase(getScreenshot.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = mediaSlice.actions
export default mediaSlice.reducer